import { render, staticRenderFns } from "./RequestTransfers.vue?vue&type=template&id=63c7fe16&scoped=true&"
import script from "./RequestTransfers.vue?vue&type=script&lang=js&"
export * from "./RequestTransfers.vue?vue&type=script&lang=js&"
import style0 from "./RequestTransfers.vue?vue&type=style&index=0&id=63c7fe16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c7fe16",
  null
  
)

export default component.exports